module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Blender-2937906b10947b80cea5b44a50061f45.svg";